import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Trees, Map, Library, LogIn } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        if (response.data.logo_url) {
          setLogoUrl(response.data.logo_url);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSettings();
  }, []);

  if (isAdminRoute) {
    return <div className="min-h-screen">{children}</div>;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-50 backdrop-blur-md bg-white/70 border-b border-border">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link 
              to="/" 
              className="flex items-center gap-2 text-primary font-heading text-xl font-bold tracking-tight"
              data-testid="logo-link"
            >
              {logoUrl ? (
                <img src={logoUrl} alt="TreeMuseum" className="h-10 w-auto max-w-[200px] object-contain" />
              ) : (
                <>
                  <Trees className="w-7 h-7" />
                  <span>TreeMuseum</span>
                </>
              )}
            </Link>
            
            <div className="flex items-center gap-6">
              <Link
                to="/"
                className={`flex items-center gap-2 text-sm font-medium transition-colors hover:text-primary ${
                  location.pathname === '/' ? 'text-primary' : 'text-muted-foreground'
                }`}
                data-testid="home-nav-link"
              >
                <Trees className="w-4 h-4" />
                Home
              </Link>
              <Link
                to="/map"
                className={`flex items-center gap-2 text-sm font-medium transition-colors hover:text-primary ${
                  location.pathname === '/map' ? 'text-primary' : 'text-muted-foreground'
                }`}
                data-testid="map-nav-link"
              >
                <Map className="w-4 h-4" />
                Map
              </Link>
              <Link
                to="/gallery"
                className={`flex items-center gap-2 text-sm font-medium transition-colors hover:text-primary ${
                  location.pathname === '/gallery' ? 'text-primary' : 'text-muted-foreground'
                }`}
                data-testid="gallery-nav-link"
              >
                <Library className="w-4 h-4" />
                Gallery
              </Link>
              <Link
                to="/admin/login"
                className="flex items-center gap-2 text-sm font-medium text-muted-foreground transition-colors hover:text-primary"
                data-testid="admin-nav-link"
              >
                <LogIn className="w-4 h-4" />
                Admin
              </Link>
            </div>
          </div>
        </nav>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-border bg-white/50 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div className="flex items-center gap-2 text-primary font-heading text-lg font-bold">
              {logoUrl ? (
                <img src={logoUrl} alt="TreeMuseum" className="h-10 w-auto max-w-[200px] object-contain" />
              ) : (
                <>
                  <Trees className="w-6 h-6" />
                  <span>TreeMuseum</span>
                </>
              )}
            </div>
            <p className="text-sm text-muted-foreground md:text-right">
              © 2025 TreeMuseum. Celebrating Australian trees through sound and story.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;